import React from "react"
import "./hprogramme.css"

const reasons = [
  {
    icon: "fa fa-chalkboard-teacher",
    reason: "Professional Training Approach",
    meaning: "Complex concepts broken into simple, practical lessons — no jargon, no confusion.",
  },
  {
    icon: "fa fa-chart-line",
    reason: "Hands-On Learning",
    meaning: "You analyse live markets, not just slides. Real charts, real decisions, real results.",
  },
  {
    icon: "fa fa-user-tie",
    reason: "Experienced Mentorship",
    meaning: "Real traders guide you through real market conditions — not textbook examples.",
  },
  {
    icon: "fa fa-laptop",
    reason: "Flexible Learning",
    meaning: "Choose in-person at Westlands, Nairobi or join online from anywhere in Africa.",
  },
  {
    icon: "fa fa-shield-alt",
    reason: "Focus on Risk Management",
    meaning: "We teach capital preservation first. Profits follow discipline — always.",
  },
  {
    icon: "fa fa-users",
    reason: "Community Support",
    meaning: "Join a growing network of Kenyan and African traders on the same journey as you.",
  },
]

const HWhyUs = () => {
  return (
    <section className="hwhyus padding">
      <div className="container">
        <div className="hprog-header">
          <p className="hprog-eyebrow">WHY ROVERS ACCESS</p>
          <h2>Why Choose Rovers Access Limited?</h2>
          <p className="hprog-sub">
            We are not just another trading course. We are a complete trading education system
            built around discipline, practicality, and long-term success.
          </p>
        </div>

        <div className="hwhyus-grid">
          {reasons.map((r, i) => (
            <div className="hwhyus-card" key={i}>
              <div className="hwhyus-icon">
                <i className={r.icon}></i>
              </div>
              <div className="hwhyus-content">
                <h4>{r.reason}</h4>
                <p>{r.meaning}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA strip */}
        <div className="hwhyus-cta">
          <div className="cta-text">
            <h3>Ready to trade with confidence?</h3>
            <p>Join hundreds of traders who chose the right path. No hype. Just skill.</p>
          </div>
          <div className="cta-actions">
            <a href="https://wa.me/254722525826" target="_blank" rel="noreferrer" className="cta-btn primary">
              <i className="fab fa-whatsapp"></i> Chat on WhatsApp
            </a>
            <a href="/contact" className="cta-btn outline">
              <i className="fa fa-envelope"></i> Send Enquiry
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HWhyUs
